import { motion } from 'motion/react';
import { ANIMATION_DURATION } from '../constants/animation';
import { amazonColors } from '../constants/colors';

const BUTTON_SIZE = 48;

// Arrow Icons
const ArrowLeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M21 5L21 19" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11 18L17 12L11 6" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 12L3 12" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ArrowRightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 5L3 19" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 18L7 12L13 6" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7 12L21 12" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

interface CenterButtonProps {
  hoveredSection: 'left' | 'right' | null;
  expandedSection: 'left' | 'right' | null;
  hasExpanded: boolean;
  onClick: () => void;
}

const CenterButton = ({ hoveredSection, expandedSection, hasExpanded, onClick }: CenterButtonProps) => {
  const getPosition = () => {
    if (expandedSection === null) {
      return '50%';
    }
    if (expandedSection === 'left') {
      return '100%';
    } else if (expandedSection === 'right') {
      return '0%';
    }
    return '50%';
  };

  const getBackgroundColor = () => {
    if (expandedSection) {
      if (expandedSection === 'left') {
        return 'var(--color-primary-500, #582DB5)';
      } else {
        return amazonColors.prime.blue;
      }
    }
    return hoveredSection === 'left' ? amazonColors.prime.blue : 'var(--color-primary-500, #582DB5)';
  };

  const getArrowIcon = () => {
    if (expandedSection) {
      return expandedSection === 'right' ? <ArrowLeftIcon /> : <ArrowRightIcon />;
    }
    return hoveredSection === 'right' ? <ArrowRightIcon /> : <ArrowLeftIcon />;
  };

  if (hoveredSection === null && !hasExpanded) {
    return null;
  }

  return (
    <motion.button
      onClick={onClick}
      className="absolute top-1/2 left-1/2 border-none rounded-full flex items-center justify-center cursor-pointer z-[3]"
      style={{
        width: `${BUTTON_SIZE}px`,
        height: `${BUTTON_SIZE}px`,
        minWidth: `${BUTTON_SIZE}px`,
        background: getBackgroundColor(),
      }}
      initial={{
        transform: 'translate(-50%, -50%)',
      }}
      animate={{
        left: getPosition(),
        transform: 'translate(-50%, -50%)',
      }}
      transition={{
        duration: ANIMATION_DURATION,
        ease: 'easeInOut',
      }}
    >
      <motion.div>{getArrowIcon()}</motion.div>
    </motion.button>
  );
};

export default CenterButton;
